// extracted by mini-css-extract-plugin
var _1 = "_505f2__colorStrip";
var _2 = "_505f2__colorStrip_show";
var _3 = "_505f2__multiplier";
var _4 = "_505f2__payoutInfo";
var _5 = "_505f2__payoutTable";
export { _1 as "colorStrip", _2 as "colorStrip_show", _3 as "multiplier", _4 as "payoutInfo", _5 as "payoutTable" }
